import { render, staticRenderFns } from "./stores_page.vue?vue&type=template&id=57d92bcc&"
import script from "./stores_page.vue?vue&type=script&lang=js&"
export * from "./stores_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports